import * as Spruce from './utils/spruce.umd';

export default {
    'Spruce': Spruce
};